<template>
  <v-app id="home">
    <v-main class="background-home">
      <view-container>
        <v-container>
          <v-row justify="end">
            <v-col cols="12" md="12">
              <h2
                style="color: #005591"
                v-text="'Registro para empleados sin usuario de red'"
              />
            </v-col>
          </v-row>
          <v-row class="mb-6 text-center" justify="center">
            <v-col cols="12" md="12" class="padding-b0">
              <BasicInput
                v-model="numEmployee"
                placeholder="Numero de empleado"
              />
            </v-col>
            <v-col cols="12" md="12" class="padding-b0">
              <BasicInput
                v-model="pass1"
                placeholder=" password"
                password
                min8
                alfaNumeric
                number
              />
            </v-col>
            <v-col cols="12" md="12" class="padding-b0 padding-t0">
              <BasicInput
                v-model="pass2"
                placeholder="Confirmar password"
                password
                min8
                alfaNumeric
                number
              />
            </v-col>
            <v-col cols="12" md="12" class="padding-b0 padding-t0">
              <basic-btn block text="Ingresar" @click="register" />
            </v-col>
            <v-col cols="12" md="12" class="float-right alignText">
              <basic-btn
                text="O inicia sesión aquí"
                typeButton="text"
                colorBtn="#005591"
                @click="$router.push('/login')"
              />
            </v-col>
          </v-row>
        </v-container>
      </view-container>
    </v-main>
  </v-app>
</template>

<script>
import {
  AutoContainer,
  ViewContainer,
  BasicInput,
  BasicBtn,
} from "@/components";
import { alertMsg } from "@/utils";

export default {
  name: "home",
  components: { AutoContainer, ViewContainer, BasicInput, BasicBtn },
  data: () => ({
    numEmployee: "",
    pass1: "",
    pass2: "",
    host: process.env.VUE_APP_API_SERVER,
    path: "/pub/registerUser",
    rules: {},
    dialogs: {},
    links: {},
  }),
  mounted() {},
  methods: {
    register() {
      if (this.pass1 === this.pass2) {
        setTimeout(() => {
          this.axios
            .post(this.host + this.path, {
              data: {
                username: this.numEmployee,
                password: this.pass1,
              },
            })
            .then((response) => {
              let res = response.data;
              for (let i = 0; i < res.roles.length; i++) {
                if (res.roles[i] != "CONDUCTOR" || res.roles.length != 0) {
                  this.auth = true;
                }
              }
              if (this.auth == true) {
                alertMsg.alert(
                  "Su registro se ha guardado exitosamente",
                  "success"
                );
                this.$session.start();
                this.$session.set("jwt", res.token);
                this.$session.set("usr", this.username);
                this.$session.set("rol", res.roles);
                this.newUser({ usr_nm: this.username, perfil: res.roles });
                this.$router.push("/login");
              } else {
                this.error = true;
                this.codeError = "UNAUTHORIZED_ACTION";
              }
            })
            .catch((error) => {
              alertMsg.alert(
                "El número de empleado no es valido o ya se encuentra registrado",
                "error"
              );
            })
            .finally(() => {
              this.loading = false;
              this.auth = false;
            });
        }, 300);
      } else {
        alertMsg.alert("Revise los passwords", "error");
      }
    },
  },
};
</script>

<style scoped>
.padding-b0 {
  padding-bottom: 0px;
}
.padding-t0 {
  padding-top: 0px;
}
.padding-t10 {
  padding-top: 10%;
}
.alignText {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>
